/**
 * Centralized board cover-color palette.
 * Adding a new entry here makes it available across:
 *   - Create board dialog (color picker)
 *   - Board card thumbnails (Dashboard/Workspace grid)
 *   - Board header gradient
 *   - Sidebar color dots
 *   - Sprints view color dots
 *
 * NOTE: All Tailwind class strings live in this file so the JIT bundler can detect them.
 */

export const BOARD_COLORS = [
  { key: "blue",     label: "Azul",        gradient: "from-blue-500 to-blue-700",        gradient80: "from-blue-500/80 to-blue-700/80",     dot: "bg-blue-500" },
  { key: "sky",      label: "Cielo",       gradient: "from-sky-500 to-sky-700",          gradient80: "from-sky-500/80 to-sky-700/80",       dot: "bg-sky-500" },
  { key: "cyan",     label: "Cian",        gradient: "from-cyan-500 to-cyan-700",        gradient80: "from-cyan-500/80 to-cyan-700/80",     dot: "bg-cyan-500" },
  { key: "teal",     label: "Verde azul",  gradient: "from-teal-500 to-teal-700",        gradient80: "from-teal-500/80 to-teal-700/80",     dot: "bg-teal-500" },
  { key: "emerald",  label: "Esmeralda",   gradient: "from-emerald-500 to-teal-700",     gradient80: "from-emerald-500/80 to-teal-700/80",  dot: "bg-emerald-500" },
  { key: "green",    label: "Verde",       gradient: "from-green-500 to-green-700",      gradient80: "from-green-500/80 to-green-700/80",   dot: "bg-green-500" },
  { key: "lime",     label: "Lima",        gradient: "from-lime-500 to-lime-700",        gradient80: "from-lime-500/80 to-lime-700/80",     dot: "bg-lime-500" },
  { key: "yellow",   label: "Amarillo",    gradient: "from-yellow-400 to-yellow-600",    gradient80: "from-yellow-400/80 to-yellow-600/80", dot: "bg-yellow-500" },
  { key: "amber",    label: "Ámbar",       gradient: "from-amber-500 to-orange-600",     gradient80: "from-amber-500/80 to-orange-600/80",  dot: "bg-amber-500" },
  { key: "orange",   label: "Naranja",     gradient: "from-orange-500 to-orange-700",    gradient80: "from-orange-500/80 to-orange-700/80", dot: "bg-orange-500" },
  { key: "red",      label: "Rojo",        gradient: "from-red-500 to-red-700",          gradient80: "from-red-500/80 to-red-700/80",       dot: "bg-red-500" },
  { key: "rose",     label: "Rosa",        gradient: "from-rose-500 to-rose-700",        gradient80: "from-rose-500/80 to-rose-700/80",     dot: "bg-rose-500" },
  { key: "pink",     label: "Magenta",     gradient: "from-pink-500 to-pink-700",        gradient80: "from-pink-500/80 to-pink-700/80",     dot: "bg-pink-500" },
  { key: "fuchsia",  label: "Fucsia",      gradient: "from-fuchsia-500 to-fuchsia-700",  gradient80: "from-fuchsia-500/80 to-fuchsia-700/80", dot: "bg-fuchsia-500" },
  { key: "purple",   label: "Púrpura",     gradient: "from-purple-500 to-purple-700",    gradient80: "from-purple-500/80 to-purple-700/80", dot: "bg-purple-500" },
  { key: "violet",   label: "Violeta",     gradient: "from-violet-500 to-violet-700",    gradient80: "from-violet-500/80 to-violet-700/80", dot: "bg-violet-500" },
  { key: "indigo",   label: "Índigo",      gradient: "from-indigo-500 to-indigo-700",    gradient80: "from-indigo-500/80 to-indigo-700/80", dot: "bg-indigo-500" },
  { key: "slate",    label: "Pizarra",     gradient: "from-slate-600 to-slate-800",      gradient80: "from-slate-600/80 to-slate-800/80",   dot: "bg-slate-500" },
];

const DEFAULT = BOARD_COLORS[0];

// Pre-built lookup maps (faster than .find() on every render)
export const GRADIENT_MAP = Object.fromEntries(BOARD_COLORS.map((c) => [c.key, c.gradient]));
export const GRADIENT80_MAP = Object.fromEntries(BOARD_COLORS.map((c) => [c.key, c.gradient80]));
export const DOT_MAP = Object.fromEntries(BOARD_COLORS.map((c) => [c.key, c.dot]));

export function gradientFor(key) {
  return GRADIENT_MAP[key] || DEFAULT.gradient;
}
export function gradient80For(key) {
  return GRADIENT80_MAP[key] || DEFAULT.gradient80;
}
export function dotFor(key) {
  return DOT_MAP[key] || DEFAULT.dot;
}
